import React, { ChangeEvent } from 'react';
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Container,
    FormControl,
    FormControlLabel,
    Grid,
    Paper,
    Radio,
    RadioGroup,
    Typography,
} from '@mui/material';
import './moving-in-bill.form.scss';
import { Link } from 'react-router-dom';
import theme from '../../../../theme';

//Props d'entrée de la fonction ContractAttachementForm
type Props = {
    handlerChangeBill: (e: ChangeEvent<HTMLInputElement>, value: string) => void;
    handlerNavigate: () => void;
    radioValue: string;
};

/**
 * Formulaire de rattachement de contrat
 * @param props les props
 * @constructor
 */
function MovingInBillForm(props: Props) {
    return (
        //Affichage en deux parties
        //Première : formulaire
        //Seconde : image
        //Affichage en deux parties
        //Première : formulaire
        //Seconde : image
        <Card className="cardMovingInBill">
            <CardHeader title={'Ajouter un contrat à votre compte'} />
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        {/*Phrase explicative pour les abonnés*/}
                        <Container sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Paper
                                elevation={2}
                                className="imgText"
                                sx={{ padding: '20px', backgroundColor: theme.palette.blue.light }}
                            >
                                {/*adresse actuelle*/}
                                <Typography variant="body1">
                                    Si vous disposez déjà d’un espace usagers, <Link to={'/'}>connectez-vous</Link> pour
                                    retrouver toutes vos données.
                                </Typography>
                                <Typography variant="body1">
                                    Si ce n’est pas encore le cas, merci de renseigner les informations suivantes.
                                </Typography>
                            </Paper>
                        </Container>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body1">Disposez-vous d'une facture ?</Typography>
                    </Grid>
                    {/*Disposez-vous d'une facture*/}
                    <Grid item xs={12}>
                        <FormControl>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={props.radioValue}
                                onChange={props.handlerChangeBill}
                            >
                                <FormControlLabel value={'t'} control={<Radio />} label="Oui" />
                                <FormControlLabel value={'f'} control={<Radio />} label="Non" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                </Grid>
            </CardContent>
            {/*Bloc action => pour les boutons*/}
            <CardActions>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={7} />
                    <Grid item xs={12} sm={5} className="buttons-form">
                        <Button variant="neutral" component={Link} to={'/'}>
                            Annuler
                        </Button>
                        {/*Bouton valider, désactivé durant le traitement du formulaire*/}
                        <Button onClick={props.handlerNavigate} variant="contained">
                            Valider
                        </Button>
                    </Grid>
                </Grid>
            </CardActions>
        </Card>
    );
}

export default MovingInBillForm;
